import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowModal(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
      } else {
        console.log('User dismissed the A2HS prompt');
      }
      setDeferredPrompt(null);
      setShowModal(false);
    });
  };

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Instalacja aplikacji</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Czy chcesz zainstalować tę aplikację na swoim urządzeniu, aby mieć do niej szybki dostęp?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Może później
        </Button>
        <Button variant="primary" onClick={handleInstall}>
          Zainstaluj
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InstallPrompt;
